export enum AdminMenu {
  Dashboards = 'dashboards',
  KeyDates = 'key-dates',
  Reports = 'reports',
  SubmissionPeriods = 'submission-periods',
  Users = 'users',
}
